import { TPermissions } from './PermissionsCell.types';

export const PERMISSION_LABELS: { key: keyof TPermissions; label: string }[] = [
  { key: 'can_create_applications', label: 'Create apps' },
  { key: 'can_upload_broker_documents', label: 'Upload docs' },
  { key: 'can_interact_with_offers', label: 'Interact with offers' },
  { key: 'can_refresh_offers', label: 'Refresh offers' },
  { key: 'can_manage_account_users', label: 'Manage users' },
];
